module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Tasks","calendar":"Calendar","list":"List","create":"New task","create-mobile":"New"},"pt-BR":{"title":"Tarefas","calendar":"Calendário","list":"Lista","create":"Nova tarefa","create-mobile":"Nova"}}')
  delete Component.options._Ctor
}
